var render, staticRenderFns
import script from "./dAlert.vue?vue&type=script&lang=js&"
export * from "./dAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377f7c06",
  null
  
)

export default component.exports